var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_1110_10887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.17538 0 0 7.17538 0 16C0 24.8246 7.17538 32 16 32C24.8246 32 32 24.8246 32 16C32 7.17538 24.8246 0 16 0Z",
    fill: "#0076FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.354 11.3843C25.354 11.052 25.2186 10.7443 24.9971 10.5104L23.9755 9.48891C23.4955 9.00891 22.7201 9.00891 22.2401 9.48891L13.8832 17.8335L9.78474 13.7351C9.30474 13.2551 8.52936 13.2551 8.04936 13.7351L7.02782 14.7566C6.79398 14.9904 6.6709 15.2981 6.6709 15.6304C6.6709 15.9628 6.80628 16.2704 7.02782 16.5043L11.9632 21.4397C11.9632 21.4397 11.9755 21.4643 11.9878 21.4766L13.0094 22.4981C13.2555 22.7443 13.5632 22.8551 13.8832 22.8551C13.8832 22.8551 13.8832 22.8551 13.8955 22.8551C14.2278 22.8551 14.5355 22.7197 14.7694 22.4981L15.7909 21.4766C15.7909 21.4766 15.8155 21.4397 15.8278 21.4274L25.0094 12.2458C25.2432 12.012 25.3663 11.7043 25.3663 11.372L25.354 11.3843Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1110_10887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCheckCircle);
export default __webpack_public_path__ + "static/media/ico-check-circle.c586f4c03a1dbc9887a20224e509c675.svg";
export { ForwardRef as ReactComponent };